// extracted by mini-css-extract-plugin
module.exports = {"Quantity":"QuantityChanger_Quantity__1d0PE"};